import { Link, Stack, type StackProps, Text } from "@chakra-ui/react";
import * as React from "react";

export interface FooterProps extends StackProps {}

export const Footer = (props: FooterProps) => {
  return (
    <Stack
      direction="row"
      justify="center"
      gap={4}
      fontSize="sm"
      color="fg.muted"
      {...props}
    >
      <Link href="/terms" textDecoration="underline">
        Terms of Service
      </Link>
      <Text>·</Text>
      <Link href="/privacy" textDecoration="underline">
        Privacy Policy
      </Link>
    </Stack>
  );
};
